'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublicMetaData = undefined;

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _dispatchAndLogError = require('pricing-pages-unified-ui/utils/dispatchAndLogError');

var _CountryToCurrency = require('pricing-pages-unified-ui/constants/CountryToCurrency');

var _CountryToCurrency2 = _interopRequireDefault(_CountryToCurrency);

var _PublicMetaDataApi = require('pricing-pages-unified-ui/api/public-only/PublicMetaDataApi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// temp formatting until reponse comes back this way from EE to match with in-app onboarding response
var formatRequiredOnboarding = function formatRequiredOnboarding(payload) {
  var formattedObj = {};
  Object.keys(payload).map(function (merchId) {
    return formattedObj[merchId] = {
      merchandiseId: merchId,
      onboardingMerchandiseId: payload[merchId],
      onboardingRequired: true
    };
  });
  return formattedObj;
};

var fetchPublicMetaData = exports.fetchPublicMetaData = function fetchPublicMetaData() {
  return function (dispatch) {
    dispatch({ type: _ActionTypes2.default.PUBLIC_META_DATA_REQUESTED });
    return (0, _PublicMetaDataApi.getPublicMetaData)().then(function (resp) {
      dispatch({
        type: _ActionTypes2.default.PUBLIC_META_DATA_RECEIVED
      });

      var country = resp.country,
          promotions = resp.promotions,
          requiredOnboarding = resp.requiredOnboarding,
          phoneNumbers = resp.phoneNumbers;


      var formattedRequiredOnboarding = formatRequiredOnboarding(requiredOnboarding);

      // TODO: once in-app can get countryCode too,
      // just use countryCode instead of full country string
      dispatch({
        type: _ActionTypes2.default.COUNTRY_RECEIVED,
        payload: { country: country }
      });

      // TODO: Get currency from this endpoint too so we can kill this map
      var currency = _CountryToCurrency2.default[country];
      if (currency) {
        dispatch({
          type: _ActionTypes2.default.ACTIVE_CURRENCY_CODE_UPDATED,
          payload: { currency: currency }
        });
      }

      dispatch({
        type: _ActionTypes2.default.ELIGIBLE_PROMOTIONS_RECEIVED,
        payload: promotions
      });

      dispatch({
        type: _ActionTypes2.default.REQUIRED_ONBOARDING_RECEIVED,
        payload: formattedRequiredOnboarding
      });

      dispatch({
        type: _ActionTypes2.default.PHONE_NUMBERS_RECEIVED,
        payload: { phoneNumbers: phoneNumbers }
      });
    }).catch(function (error) {
      (0, _dispatchAndLogError.dispatchAndLogError)({
        dispatch: dispatch,
        type: _ActionTypes2.default.PUBLIC_META_DATA_FAILED,
        error: error
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/public-only/PublicMetaDataActions.js
// module id = 878
// module chunks = 4